import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/ImageSlider.css"; // Create this file for custom styles

const ImageSlider = ({ images }) => {
  const settings = {    
    dots: true,
    
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "linear",
    prevArrow: <div className="slick-prev">Previous</div>,
  nextArrow: <div className="slick-next">Next</div>,

    
  };

  return (
    <div  className="image-slider">
      <Slider {...settings} >
        {images.map((image, index) => (
          <div key={index}>
            <img  src={image} alt={`Slide ${index}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;